import React from 'react';
import { Pressable, StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';
import { useUniqueNativeID } from '../../../../hooks';
import { BodyText } from '../../../Text';
import { CollapseIndicatorIcon } from '../../../Collapsible';
import type { PickerTriggerProps } from '../Picker.types';

// ────────────────────────────────────────────────────────────────────────────────

export const PickerTrigger = (props: PickerTriggerProps) => {
  const {
    label,
    selectedOption,
    expanded,
    variation = 'standard',
    onPress,
  } = props;
  const labelNativeID = useUniqueNativeID('picker-trigger-label');
  const isBoxVariation = variation === 'box';
  const triggerStyle = [styles.trigger, isBoxVariation && styles.triggerBox];

  return (
    <View>
      {label ? (
        <BodyText
          nativeID={labelNativeID}
          size={4}
          style={isBoxVariation ? styles.labelWithSpacing : undefined}
        >
          {label}
        </BodyText>
      ) : null}

      <Pressable
        testID="sg-picker-trigger"
        style={triggerStyle}
        onPress={onPress}
        accessibilityRole="button"
        accessibilityExpanded={expanded}
        accessibilityDescribedBy={labelNativeID}
      >
        <BodyText size={4} bold={!isBoxVariation}>
          {selectedOption}
        </BodyText>

        <CollapseIndicatorIcon expanded={expanded} />
      </Pressable>
    </View>
  );
};

// ─── STYLES ─────────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  labelWithSpacing: {
    paddingBottom: theme.spacing['2'],
  },
  trigger: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  triggerBox: {
    borderRadius: theme.radius.small,
    borderWidth: 1,
    borderColor: theme.colors.GRAY,
    paddingVertical: 0,
    paddingHorizontal: theme.spacing['2'],
    minHeight: 32,
  },
});
